/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import React from 'react';
import { amountComparator } from '../../../../SharedModules/utilities/utilities';
const comparator = (a, b) => {
  return new Date(a) - new Date(b);
};

const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

const textMatcher = ({ filterOption, value: val, filterText }) => {
  let value = val.split(',').join('');
  if (filterText == null) {
    return false;
  }

  switch (filterOption) {
    case 'contains':
      return value.indexOf(filterText) >= 0;
    case 'notContains':
      return value.indexOf(filterText) < 0;
    case 'equals':
      return value === filterText;
    case 'notEqual':
      return value != filterText;
    case 'startsWith':
      return value.indexOf(filterText) === 0;
    case 'endsWith':
      const index = value.lastIndexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  let value = Math.abs(parseFloat(val.split(',').join('').substring(1)));
  value = '$' + value;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return value.indexOf(filterText) >= 0;
    case 'notContains':
      return value.indexOf(filterText) < 0;
    case 'equals':
      return value === filterText;
    case 'notEqual':
      return value != filterText;
    case 'startsWith':
      return value.indexOf(filterText) === 0;
    case 'endsWith':
      const index = value.lastIndexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

const cellRenderer = (params) => {
  if (params?.data?.isBottomRow) {
    return <b>{params.value}</b>;
  }
  return params.value;
};
export const RequestMonthlyClaimReconciliationTableHead = [
  {
    headerName: 'Start Date',
    field: 'startDate',
    editable: false,
    suppressMenu: false,
    comparator,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapText: true,
    autoHeight: true,
    comparator,
    cellStyle: { borderRightColor: Styles.BorderColor },

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Requestor User Id',
    field: 'requestorUserId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapText: true,
    autoHeight: true,
    cellStyle: { borderRightColor: Styles.BorderColor },

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Requested Date',
    field: 'requestedDate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rightHead = [
  {
    headerName: 'Load Date',
    field: 'loadDate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator,
    cellRenderer,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prefix',
    field: 'prefixTag',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'descr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_250,
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Count',
    field: 'count',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    excelAlignment: 'right',
    isTextColorRed: true,
    comparator: amountComparator,
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellRenderer,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
  },
  {
    headerName: 'ReimbAmount',
    field: 'reimbAmount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_160,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { textAlign: 'right' },
    comparator: (a, b, nodeA, nodeB, isDescending) => {
      return (
        parseInt(a.split(',').join('').substring(1)) -
        parseInt(b.split(',').join('').substring(1))
      );
    },
    cellRenderer,

    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },
];

export const leftHead = [
  {
    headerName: 'Load Date',
    field: 'claimLoadDate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    comparator,
    cellRenderer,
    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    wrapText: true,
    cellStyle: { borderRightColor: Styles.BorderColor },
    comparator: comparatorQtr,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    // comparator: countComparator,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_138,
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    cellClass:(params)=>(params.data?._subTotalLabelCell? "_subTotalLabelCell":""),
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Count',
    field: 'recordCount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    excelAlignment: 'right',
    isTextColorRed: true,
    comparator: amountComparator,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellRenderer,

    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
  },
];
